import styled from 'styled-components';
import { colors } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
export const DCHMessageBox = styled(MessageBox) `
  background-color: ${colors.turquoiseLightest};
  border-color: ${colors.turquoise};
`;
